import accomodationIcon from '../assets/images/poi/accomodation-white.svg';
import anticsIcon from '../assets/images/poi/antics-white.svg';
import beachIcon from '../assets/images/poi/beach-white.svg';
import bicycleHomeIcon from '../assets/images/poi/bicycle-home-white.svg';
import bicycleRentalIcon from '../assets/images/poi/bicycle-rental-white.svg';
import bicycleRepairIcon from '../assets/images/poi/bicycle-repair-white.svg';
import campingIcon from '../assets/images/poi/camping-white.svg';
import castleIcon from '../assets/images/poi/castle-white.svg';
import chargingStationIcon from '../assets/images/poi/charging-station-white.svg';
import collectiveIcon from '../assets/images/poi/collective-white.svg';
import fortificationIcon from '../assets/images/poi/fortification-white.svg';
import gardenIcon from '../assets/images/poi/garden-white.svg';
import industryIcon from '../assets/images/poi/industry-white.svg';
import museumIcon from '../assets/images/poi/museum-white.svg';
import naturalSiteIcon from '../assets/images/poi/natural-site-white.svg';
import picnicIcon from '../assets/images/poi/picnic-white.svg';
import pumpIcon from '../assets/images/poi/pump-white.svg';
import remarkableCityIcon from '../assets/images/poi/remarkable-city-white.svg';
import restaurantIcon from '../assets/images/poi/restaurant-white.svg';
import ruinsIcon from '../assets/images/poi/ruins-white.svg';
import thermalStationIcon from '../assets/images/poi/thermal-station-white.svg';
import toDoToSeeIcon from '../assets/images/poi/to-do-to-see-white.svg';
import toiletsIcon from '../assets/images/poi/toilets-white.svg';
import tourismOfficeIcon from '../assets/images/poi/tourism-office-white.svg';
import usefulIcon from '../assets/images/poi/useful-white.svg';
import viewPointIcon from '../assets/images/poi/view-point-white.svg';
import waterPointIcon from '../assets/images/poi/water-point-white.svg';
import { PoiCategory } from '../models';
import { HttpService } from './http';
import { parseLavCategories } from './poi-category-lav';
export class PoiCategoryService {
  static async getPoiCategories({
    widgetConfig
  } = {}) {
    try {
      const data = await HttpService.get('v1', '/poi_categories');
      const categories = parsePoiCategories(data);
      if (widgetConfig?.code === 'lav') {
        const codes = ['bicyclePump', 'chargingStation', 'drinkingWater', 'picnic', 'toilets'];
        const filteredCategories = categories.filter(({
          code
        }) => codes.indexOf(code) > -1);
        return [...parseLavCategories(Math.max(...categories.map(({
          id
        }) => id)) + 1), ...filteredCategories];
      }
      return categories;
    } catch (err) {
      console.error('[PoiCategoryService][getPoiCategories]', err);
      throw err;
    }
  }
}
export const poiBackendCategoryCodes = {
  accomodation: 'ACCOMODATION',
  antics: 'ANTICS',
  beach: 'BEACH',
  bicycle: 'BICYCLE',
  bicycleHome: 'BICYCLE_HOME',
  bicycleParking: 'BICYCLE_PARKING',
  bicyclePump: 'BICYCLE_PUMP',
  bicycleRental: 'BICYCLE_RENTAL',
  bicycleRepair: 'BICYCLE_REPAIR',
  bnb: 'BnB',
  camping: 'CAMPING',
  castle: 'CASTLE',
  cave: 'CAVE',
  chargingStation: 'CHARGING_STATION',
  collective: 'COLLECTIVE',
  drinkingWater: 'DRINKING_WATER',
  fortification: 'FORTIFICATION',
  garden: 'GARDEN',
  holidayVillage: 'HOLIDAY_VILLAGE',
  hotel: 'HOTEL',
  industry: 'INDUSTRY',
  leisurePark: 'LEISURE_PARK',
  museum: 'MUSEUM',
  naturalSite: 'NATURAL_SITE',
  picnic: 'PICNIC',
  religious: 'RELIGIOUS',
  remarkableCity: 'REMARKABLE_CITY',
  residence: 'RESIDENCE',
  restaurant: 'RESTAURANT',
  ruins: 'RUINS',
  smallHeritage: 'SMALL_HERITAGE',
  sport: 'SPORT',
  thermalCenter: 'THERMAL_CENTER',
  toDoToSee: 'TO_DO_TO_SEE',
  toilets: 'TOILETS',
  tourism: 'TOURISM',
  tourismOffice: 'TOURISM_OFFICE',
  tourismSite: 'TOURISM_SITE',
  useful: 'USEFUL',
  viewPoint: 'VIEWPOINT'
};
export const poiCategoryCodesMap = {
  ACCOMODATION: 'accomodation',
  ANTICS: 'antics',
  BEACH: 'beach',
  BICYCLE: 'bicycle',
  BICYCLE_HOME: 'bicycleHome',
  BICYCLE_PARKING: 'bicycleParking',
  BICYCLE_PUMP: 'bicyclePump',
  BICYCLE_RENTAL: 'bicycleRental',
  BICYCLE_REPAIR: 'bicycleRepair',
  BnB: 'bnb',
  CAMPING: 'camping',
  CASTLE: 'castle',
  CAVE: 'cave',
  CHARGING_STATION: 'chargingStation',
  COLLECTIVE: 'collective',
  DRINKING_WATER: 'drinkingWater',
  // EVENT: 'event',
  // EVENT_CULTURAL: 'eventCultural',
  // EVENT_FLEA_MARKET: 'eventFleaMarket',
  // EVENT_LOCAL: 'eventLocal',
  // EVENT_MARKET: 'eventMarket',
  // EVENT_SPORT: 'eventSport',
  // EVENT_VISIT: 'eventVisit',
  FORTIFICATION: 'fortification',
  GARDEN: 'garden',
  HOLIDAY_VILLAGE: 'holidayVillage',
  HOTEL: 'hotel',
  INDUSTRY: 'industry',
  LEISURE_PARK: 'leisurePark',
  MUSEUM: 'museum',
  NATURAL_SITE: 'naturalSite',
  PICNIC: 'picnic',
  RELIGIOUS: 'religious',
  REMARKABLE_CITY: 'remarkableCity',
  RESIDENCE: 'residence',
  RESTAURANT: 'restaurant',
  // ROADWORK: 'roadwork',
  RUINS: 'ruins',
  SMALL_HERITAGE: 'smallHeritage',
  SPORT: 'sport',
  THERMAL_CENTER: 'thermalCenter',
  TO_DO_TO_SEE: 'toDoToSee',
  TOILETS: 'toilets',
  TOURISM: 'tourism',
  TOURISM_OFFICE: 'tourismOffice',
  TOURISM_SITE: 'tourismSite',
  USEFUL: 'useful',
  VIEWPOINT: 'viewPoint'
};
export const poiCategoryOrders = {
  bicycleParking: 1,
  bicyclePump: 2,
  bicycleRepair: 3,
  chargingStation: 4,
  drinkingWater: 5,
  toilets: 6,
  picnic: 7,
  bicycleRental: 8,
  accomodation: 9,
  toDoToSee: 10,
  restaurant: 11
};
export const poiCategoryLabelKeys = {
  accomodation: 'commons.poi.categories.accomodation',
  antics: 'commons.poi.categories.antics',
  beach: 'commons.poi.categories.beach',
  bicycle: 'commons.poi.categories.bicycle',
  bicycleHome: 'commons.poi.categories.bicycle_home',
  bicycleParking: 'commons.poi.categories.parking_other',
  bicyclePump: 'commons.poi.categories.bicycle_pump',
  bicycleRental: 'commons.poi.categories.bicycle_rental',
  bicycleRepair: 'commons.poi.categories.bicycle_repair',
  bnb: 'commons.poi.categories.bnb',
  camping: 'commons.poi.categories.camping',
  castle: 'commons.poi.categories.castle',
  cave: 'commons.poi.categories.cave',
  chargingStation: 'commons.poi.categories.charging_station',
  collective: 'commons.poi.categories.collective',
  drinkingWater: 'commons.poi.categories.drinking_water',
  fortification: 'commons.poi.categories.fortification',
  garden: 'commons.poi.categories.garden',
  holidayVillage: 'commons.poi.categories.holiday_village',
  hotel: 'commons.poi.categories.hotel',
  industry: 'commons.poi.categories.industry',
  leisurePark: 'commons.poi.categories.leisure_park',
  museum: 'commons.poi.categories.museum',
  naturalSite: 'commons.poi.categories.natural_site',
  picnic: 'commons.poi.categories.picnic',
  religious: 'commons.poi.categories.religious',
  remarkableCity: 'commons.poi.categories.remarkable_city',
  residence: 'commons.poi.categories.residence',
  restaurant: 'commons.poi.categories.restaurant',
  ruins: 'commons.poi.categories.ruins',
  smallHeritage: 'commons.poi.categories.small_heritage',
  sport: 'commons.poi.categories.sport',
  thermalCenter: 'commons.poi.categories.thermal_center',
  toDoToSee: 'commons.poi.categories.to_do_to_see',
  toilets: 'commons.poi.categories.toilets',
  tourism: 'commons.poi.categories.tourism',
  tourismOffice: 'commons.poi.categories.tourism_office',
  tourismSite: 'commons.poi.categories.tourism_site',
  useful: 'commons.poi.categories.useful',
  viewPoint: 'commons.poi.categories.viewpoint'
};
export const poiCategoryColors = {
  accomodation: '#24549e',
  antics: '#957360',
  beach: '#24549e',
  bicycleHome: '#24549e',
  bicyclePump: '#595959',
  bicycleRepair: '#51aa4a',
  bicycleRental: '#957360',
  camping: '#e18d51',
  castle: '#957360',
  chargingStation: '#deaa44',
  drinkingWater: '#2699cb',
  fortification: '#957360',
  garden: '#00885f',
  industry: '#595959',
  museum: '#8551c7',
  naturalSite: '#00885f',
  picnic: '#51aa4a',
  remarkableCity: '#bd64ba',
  restaurant: '#e18d51',
  ruins: '#595959',
  thermalCenter: '#2699cb',
  toDoToSee: '#bd64ba',
  tourismOffice: '#e18d51',
  useful: '#868686',
  viewPoint: '#deaa44'
};
export const poiCategoryIcons = {
  accomodation: accomodationIcon,
  antics: anticsIcon,
  beach: beachIcon,
  bicycleHome: bicycleHomeIcon,
  bicyclePump: pumpIcon,
  bicycleRental: bicycleRentalIcon,
  bicycleRepair: bicycleRepairIcon,
  camping: campingIcon,
  castle: castleIcon,
  chargingStation: chargingStationIcon,
  collective: collectiveIcon,
  drinkingWater: waterPointIcon,
  fortification: fortificationIcon,
  garden: gardenIcon,
  hotel: accomodationIcon,
  industry: industryIcon,
  museum: museumIcon,
  naturalSite: naturalSiteIcon,
  picnic: picnicIcon,
  remarkableCity: remarkableCityIcon,
  restaurant: restaurantIcon,
  ruins: ruinsIcon,
  thermalCenter: thermalStationIcon,
  toDoToSee: toDoToSeeIcon,
  toilets: toiletsIcon,
  tourismOffice: tourismOfficeIcon,
  useful: usefulIcon,
  viewPoint: viewPointIcon
};
function parsePoiCategories(_categories) {
  const parentCodes = ['BICYCLE', 'USEFUL', 'TOURISM'];
  const categories = [{
    id: -1,
    code: 'BICYCLE',
    parent: null
  }, {
    id: -3,
    code: 'TOURISM',
    parent: null
  }, ..._categories].filter(({
    code
  }) => code && poiCategoryCodesMap[code]).map(data => {
    if (data.code && ['BICYCLE_PUMP', 'BICYCLE_REPAIR', 'CHARGING_STATION'].includes(data.code)) return {
      ...data,
      parent: -1
    };
    if (data.code && ['BICYCLE_RENTAL', 'ACCOMODATION', 'TO_DO_TO_SEE', 'RESTAURANT'].includes(data.code)) return {
      ...data,
      parent: -3
    };
    return data;
  });
  let order = 1000;
  return parentCodes.reduce((res, _code) => {
    const code = poiCategoryCodesMap[_code];
    const category = categories.find(({
      code
    }) => code === _code);
    if (code && category) {
      const parentColor = poiCategoryColors[code];
      const parentIcon = poiCategoryIcons[code];
      const _children = categories.filter(({
        parent
      }) => parent === category.id);
      const children = _children.map(({
        id: childId,
        code: _childCode
      }) => {
        const childCode = poiCategoryCodesMap[_childCode];
        return new PoiCategory(childId, childCode, poiCategoryLabelKeys[childCode], poiCategoryColors[childCode] || parentColor, poiCategoryIcons[childCode] || parentIcon, code, categories.filter(({
          parent
        }) => parent === childId).map(({
          id: childChildId,
          code: _childChildCode
        }) => {
          const childChildCode = poiCategoryCodesMap[_childChildCode];
          return new PoiCategory(childChildId, childChildCode, poiCategoryLabelKeys[childChildCode], poiCategoryColors[childChildCode] || poiCategoryColors[childCode] || parentColor, poiCategoryIcons[childChildCode] || poiCategoryIcons[childCode] || parentIcon, code, [], poiCategoryOrders[childChildCode] || order++);
        }), poiCategoryOrders[childCode] || order++);
      });
      res.push(new PoiCategory(category.id, code, poiCategoryLabelKeys[code], parentColor, parentIcon, null, children, poiCategoryOrders[code] || order++), ...children);
    }
    return res;
  }, []);
}